import { render, staticRenderFns } from "./ModuloVacina.vue?vue&type=template&id=63573341&"
import script from "./ModuloVacina.vue?vue&type=script&lang=js&"
export * from "./ModuloVacina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports